import axios from 'axios'
const HomepageApi = {

    async fetchAll() {
        return await axios.get('/api/homepage')
    }
}

export default HomepageApi